import { isDefined, isNotEmpty } from './utils/inspect';
import { map } from './utils/arrays';
export function background() {
    return map(arguments, function (background) {
        return [
            background.image,
            background.position,
            background.size,
            background.repeat,
            background.origin,
            background.clip,
            background.attachment,
            background.color
        ]
            .filter(isDefined)
            .join(' ');
    })
        .filter(isNotEmpty)
        .join(',');
}
